
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1502Dialog extends Serenity.EntityDialog<Report_1502Row, any> {
        protected getFormKey() { return Report_1502Form.formKey; }
        protected getIdProperty() { return Report_1502Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1502Row.localTextPrefix; }
        protected getNameProperty() { return Report_1502Row.nameProperty; }
        protected getService() { return Report_1502Service.baseUrl; }
        protected getDeletePermission() { return Report_1502Row.deletePermission; }
        protected getInsertPermission() { return Report_1502Row.insertPermission; }
        protected getUpdatePermission() { return Report_1502Row.updatePermission; }

        protected form = new Report_1502Form(this.idPrefix);

    }
}